import {
  Button,
  IconButton,
  lighten,
  styled,
  Switch,
  SwitchProps,
} from '@mui/material';

export const BackButton = styled(IconButton)(({ theme }) => ({
  '& span': { fontSize: '40px', color: theme.palette.secondary.main },
}));

export const DownloadButton = styled(Button)(() => ({
  display: 'flex',
  gap: '10px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 48,
  height: 24,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        backgroundColor: '#06DFC2',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#06DFC2',
      border: `6px solid ${theme.palette.common.white}`,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
    '&.Mui-checked.Mui-disabled + .MuiSwitch-track': {
      backgroundColor: '#06DFC2',
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 24 / 2,
    backgroundColor: lighten(theme.palette.common.grey, 0.5),
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

export const CloseIcon = styled(IconButton)(({ theme }) => ({
  right: '20px',
  top: '20px',
  position: 'absolute',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

interface OutlinedButtonProps {
  width?: string;
}

export const OutlinedButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'width',
})<OutlinedButtonProps>(({ theme }) => ({
  width: '200px',
  display: 'flex',
  border: `1px solid ${theme.palette.secondary.main}`,
  color: theme.palette.secondary.main,
  backgroundColor: 'transparent',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

interface FilledButtonProps {
  width?: string;
  model?: string;
}

export const FilledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'width' && prop !== 'model',
})<FilledButtonProps>(({ theme, model }) => ({
  backgroundColor: theme.palette.primary.dark,
  '&:hover': {
    backgroundColor: '',
    filter: 'brightness(85%)',
  },

  ...(model === 'error' && {
    backgroundColor: theme.palette.common.danger,
    '&:hover': {
      backgroundColor: theme.palette.common.danger,
      filter: 'brightness(85%)',
    },
    '&:active': {
      backgroundColor: theme.palette.common.danger,
    },
  }),
}));

interface StandardButtonProps {
  resize?: string;
}

export const StandardButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'resize',
})<StandardButtonProps>(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  width: '250px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
